import { render, staticRenderFns } from "./DhmeStationDashboardAssemblyTaskCard.vue?vue&type=template&id=47d22eae&scoped=true"
import script from "./DhmeStationDashboardAssemblyTaskCard.vue?vue&type=script&lang=js"
export * from "./DhmeStationDashboardAssemblyTaskCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d22eae",
  null
  
)

export default component.exports